<template lang="html">

  <div class="model-list" v-if="segmentCars.length > 0" id="segment">
   <div class="container">
      <h4 v-if="!noHead"><span class="mouseover">Bekijk alle EV Auto's</span></h4>
      <h2 v-if="!noHead">Vergelijk auto's in het {{getSegment(model.motor[0].typeinformation[0].cSegmentAdvanced)}} segment</h2>
      <div class="row p30 max-w-10">

        <div v-swiper:mySwiper="swiperOption">

          <div class="swiper-wrapper">
          <div class="col-md-6 pt-6 col-xl-4 col-block text-center p-relative car-block swiper-slide" v-for="model in segmentCars">
             <div class="ad-logo">
              <div class="outer-spin">
                <div class="outer-arc outer-arc_start-a"></div>
                <div class="outer-arc outer-arc_end-a"></div>
                <div class="outer-arc outer-arc_start-b"></div>
                <div class="outer-arc outer-arc_end-b"></div>
                <div class="outer-moon-a"></div>
                <div class="outer-moon-b"></div>
              </div>
            </div>
             <div itemscope="itemscope" itemtype="https://schema.org/Car" class="vergelijk future">
               <div class="badge-verwacht" v-if="!model.bActueel">
                   <span>Verwacht</span>
               </div>
                <span itemprop="sku" class="d-none">{{model.nModelID}}</span>
                <div class="pattern bg-white position-relative">
                  <img class="car car-image" :src="'https://media.autodisk.nl/fotos/geel/'+model.nModelID+'/16-9/300/a.jpg'"
                     :alt="model.cMerknaam+' '+model.cModelnaam" itemprop="image"
                     :key="'car-image-' + model.nModelID" loading="lazy" 
                      onerror="this.onerror=null;this.srcset='/banner.png';"
                     width="300" height="169" 
                     :srcset="`${'https://media.autodisk.nl/fotos/geel/'+model.nModelID+'/16-9/600/a.jpg'} 1920w, ${'https://media.autodisk.nl/fotos/geel/'+model.nModelID+'/16-9/300/a.jpg'} 350w`"
                     >
                  <Shape class="position-absolute shape"/>
                </div>
                <h2 class="text-colored mt-15 f22" itemprop="name">
                  <span itemprop="brand">{{model.cMerknaam}}</span>
                  {{model.cModelnaam}}
                </h2>
                <p class="text-center p0 p-0">
                  <span v-for="(motor,index) in model.motor">
                    <nuxt-link :to="getRoute(model, 'elektrische-auto')+getTypeRoute(motor)">{{motor.cTypenaam_1}} ({{Math.round(parseInt(motor.typeinformation[0].Vermogen_elektromotor_kW)*1.36)}}pk)</nuxt-link><span v-if="(index+1) == model.motor.length"></span> <span v-else>, </span>
                  </span>
                </p>
                <p itemprop="description">
                  De {{model.cMerknaam +' '+model.cModelnaam}} is een elektrische auto uit het {{getSegment(model.motor[0].typeinformation[0].cSegmentcode)}} segment
                </p>
                <div itemprop="offers" itemscope="itemscope" itemtype="http://schema.org/Offer">
                   <p class="p-0 price"><b><span itemprop="priceCurrency" content="EUR">€</span> <span itemprop="price">{{carPrice(model.nLPrijs)}}</span>,-</b></p>
                  <div class="mx-4 mb-3 d-flex justify-content-center flex-wrap">
                    <span :key="`badge-${i}`" class="badge badge-pill badge-vergelijking" :class="`badge-vergelijking--${badge.type}`" v-for="badge, i in getBadges(model)">
                      <i class="mdi" :class="`mdi-${badge.icon}`"></i><span class="badge__text">{{badge.value}} {{badge.message}}</span>
                    </span>
                  </div>
                  <div class="row">
                     <div class="col-md-12 ">
                       <nuxt-link :to="getRouteCarTCO(model, 'vergelijk/autokosten')" @click.native="reportEvent('tco', model)" class="specs secondary">Autokosten</nuxt-link>
                       <nuxt-link :to="getRoute(model, 'elektrische-auto')" @click.native="reportEvent('specs', model)" class="specs" itemprop="url">Specificaties</nuxt-link>
<!--                       <nuxt-link :to="getRoute(model, 'vergelijk/specificaties')" @click.native="reportEvent('specs', model)" class="specs" style="background: #28a745" itemprop="url">Vergelijk</nuxt-link>-->
                     </div>
                   </div>
                </div>
             </div>
           </div>
          </div>

        </div>

      </div>
   </div>
</div>
</template>

<script>
import SegmentModule  from '~/modules/segment'
import CurrencyModule from '~/modules/currency'
import Shape          from '@/components/design/shape'


export default {
  props:['model','segmentCars', 'noHead'],
  components: {
    Shape
  },
  mixins: [SegmentModule, CurrencyModule],
  data(){
    return {
        segments: [],
        swiperOption: {
            // slidesPerView: 3,
            slidesPerView: 'auto',

            // spaceBetween: 0,
            loop: true,
            pagination: {
              el: '.swiper-pagination',
              clickable: true
            },
          }
    }
  },
  methods:{
    //
    reportEvent(event, model){
      this.$gtag('event', `clicked-comparable-vehicle-${event}`, {
        event_category: 'Model Overview',
        event_label: model.cModelnaam,
        value: model.nModelID,
      });
    },
    getBadges(comparedCar){
      let badgeArray = [];

      let chosenCar = this.model;
      // Actieradius
      if(chosenCar.nLActieradius < comparedCar.nLActieradius){
        badgeArray.push({
          type: "success",
          icon: "plus",
          value: `${Math.round(comparedCar.nLActieradius - chosenCar.nLActieradius)} km`,
          message: "meer actieradius",
        })
      }else {
        badgeArray.push({
          type: "danger",
          icon: "minus",
          value: `${Math.round(chosenCar.nLActieradius - comparedCar.nLActieradius)} km`,
          message: "minder actieradius",
        })
      }
      // Price
      if(chosenCar.nLPrijs > comparedCar.nLPrijs){
        if(Math.round(chosenCar.nLPrijs - comparedCar.nLPrijs) > 100) {
          badgeArray.push({
            type: "success",
            icon: "plus",
            value: `€ ${Math.round(chosenCar.nLPrijs - comparedCar.nLPrijs).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}`,
            message: "goedkoper",
          })
        }
      }else {
        if(Math.round(comparedCar.nLPrijs - chosenCar.nLPrijs) > 100){
          badgeArray.push({
            type: "danger",
            icon: "minus",
            value: `€ ${Math.round(comparedCar.nLPrijs - chosenCar.nLPrijs).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}`,
            message: "duurder",
          })
        }

      }
      return badgeArray.sort((a, b) => (a.type < b.type) ? 1 : -1);
    },
    getSegment(segmentCode){
      return SegmentModule.getSegmentBySegmentCode(segmentCode)
    },
    carPrice(price){
      return CurrencyModule.carPrice(price)
    },

    /**
    * @method ROUTER
    * @return PAGE
    */
    getRoute(model, prefix){
      const seoModel = model.cMerknaam+'-'+model.cModelnaam.replace(/\s+/g, '-');
      const id = model.nModelID
      return '/'+prefix+'/'+id+'/'+seoModel;
    },
    getRouteCarTCO(model, prefix){
      var motor = model.motor[0].typeinformation[0];
      const seoModel = model.cMerknaam+'-'+model.cModelnaam.replace(/\s+/g, '-')+'-'+motor.cTypenaam_1.replace(/\s+/g, '-')+'-'+motor.cTypenaam_2.replace(/\s+/g, '-');
      const id = motor.nTypeIDHist
      return '/'+prefix+'/'+id+'/'+seoModel;
    },
    getTypeRoute(motor){
      const type1 = motor.typeinformation[0].cTypenaam_1.replace(/\s+/g, '-')
      const type2 = motor.typeinformation[0].cTypenaam_2.replace(/\s+/g, '-')
      return '/'+type1+'-'+type2;
    }
  }
}
</script>

<style lang="css">
#segment{
  padding-top:60px;
}
#segment h2:first-letter {
    text-transform: uppercase;
}
.swiper-container{
      padding-top: 34px;
}
</style>
